import { useTranslation } from 'react-i18next'

import { calculateItemTotal } from '@entities/Product/helpers'

import { useCartStore } from '@features/cart/model/useCartStore'

import { Product } from '@shared/generated'
import { useProductUnit } from '@shared/hooks'
import { cn } from '@shared/lib/cn'
import { formatPrice } from '@shared/uttils'

import styles from './styles.module.scss'

interface PriceBlockProps {
  product: Product;
  className?: string;
  hideOldPrice?: boolean
  showTotalPriceDiscount?: boolean
}

export default function PriceBlock ({ product, hideOldPrice = false, showTotalPriceDiscount = false, className }: PriceBlockProps) {
  const { t: tc } = useTranslation('common')
  const { getProduct } = useCartStore()
  const cartItem = getProduct(product.id)
  const amount = cartItem?.amount || 0

  const totalPrice = calculateItemTotal(
    product.priceOffer?.price as number,
    amount,
    product.priceOffer?.count_multiplier as number
  )

  const unitPrice = product.priceOffer?.price as number
  const oldPrice = product.priceOffer?.oldPrice as number
  const oldPriceTotal = calculateItemTotal(
    oldPrice,
    amount,
    product.priceOffer?.count_multiplier as number
  )

  const { unit } = useProductUnit({
    isWeightProduct: product.isWeightProduct as boolean,
    value: product.priceOffer?.count_multiplier as number,
    price: totalPrice,
    t: tc,
  })

  return (
    <div className={cn(styles.priceBlock, className)}>
      <div className={styles.priceBlock__item}>
        <div className={cn(styles.priceBlock__total, !!oldPrice && showTotalPriceDiscount ? styles['priceBlock__total--mark'] : null)}>{formatPrice(totalPrice)}</div>
        {!!oldPrice && showTotalPriceDiscount && (
          <div className={styles.priceBlock__oldTotal}>{formatPrice(oldPriceTotal)}</div>
        )}
      </div>
      {!!oldPrice && !hideOldPrice && (
        <div className={styles.priceBlock__old}>
          {formatPrice(oldPrice)}
        </div>
      )}
      <div className={styles.priceBlock__unit}>
        {formatPrice(unitPrice)} / {unit}
      </div>
    </div>
  )
}
